import { round } from './number'

const MAX_VOLTAGE = 2500 // mV

export function mvToBar(mv: number): number {
    // if (calib > 20) {
    //     const offset = piezoOffset(mv, calib)
    //     if (mv - offset < 0) {
    //         mv = 0
    //     } else {
    //         mv -= offset
    //     }
    // }
    return round((mv * 10) / MAX_VOLTAGE, 1)

    // return round((mv / ADJUSTMENT + mv) / 10, 1)
}

export function barToMv(bar: number): number {
    return Math.floor((bar * MAX_VOLTAGE) / 10)
}

// function piezoOffset(adc: number, calib: number) {
//     if (adc < 100) return calib
//     else if (adc < 150) return 62
//     else if (adc < 200) return 50
//     else if (adc < 250) return 37
//     else if (adc < 300) return 25
//     else if (adc < 350) return 17
//     else if (adc < 400) return 10
//     else if (adc < 450) return 0
//     else if (adc < 500) return -10
//     else if (adc < 550) return -17
//     else if (adc < 600) return -25
//     else if (adc < 650) return -37
//     else if (adc < 700) return -50
//     else if (adc < 750) return -62
//     else if (adc < 800) return -calib
//     else return -75
// }

// @ts-ignore
window.mvToBar = mvToBar
// @ts-ignore
window.barToMv = barToMv
